"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        item: {
            display: 'flex',
            cursor: 'initial !important',
            marginBottom: spacing(),
            backgroundColor: palette.common.white
        },
        content: {
            width: '90%'
        },
        icon: {
            width: '10%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    });
});
exports.default = useStyles;
